import Badge from 'atoms/Badge';
import Text from 'atoms/Text';
import { useEmployeeAccess } from 'lib/auth';
import Link from 'next/link';
import { RenderCR } from 'organisms/RenderCR';
import UserProfile from './UserProfile';

function ResourceProfile({
    name,
    hideProfile = false,
    textColor = 'text-green-700',
    resourceType = 'employees',
    profileImage, id, slugId,
    description, descriptionArray = [],
    isRelieving = false, relievingDate,
    isRedirectProfile = true,
    isContinuityResource = false,
    isDraft = false,
    customBadge = null,
    isNameFullWidth = false,
    alignCenter = false
}) {
    const getDescription = descriptionArray.map((i) => (i || '-'));
    const hasEmployeeAccess = useEmployeeAccess();
    return (
        <div className={`flex items-start gap-2 w-auto ${alignCenter ? 'items-center' : ''}`}>
            {
                hideProfile ? null
                    : <UserProfile
                        src={profileImage}
                        name={name}
                        height={32}
                        width={32}
                        fontSize='text-sm'
                    />
            }
            <div className='flex flex-wrap gap-1 flex-col'>
                <Text variant='label' className='whitespace-normal'>
                    {
                        hasEmployeeAccess && isRedirectProfile ? (
                            <Link href={`/${resourceType}/${slugId}`} legacyBehavior>
                                <a className={`${textColor} font-semibold text-sm`} target="_blank" rel="noopener noreferrer">
                                    {name}
                                </a>
                            </Link>
                        ) : (
                            <Text className=' font-semibold' >
                                {name} {id && <span className='text-gray-600'> ({id})</span>}
                            </Text>
                        )
                    }

                    {isContinuityResource && <RenderCR margin='ml-0.5' text="CR" tooltipText="Continuity Resource" />}

                    {id && <span className={`text-gray-600 ${isNameFullWidth ? 'block' : ''}`}> ({id})</span>}

                    {
                        isDraft && <Badge color='dark' label='Draft' className='w-fit inline-block ml-2' />
                    }
                    {
                        customBadge && <Badge color={customBadge.color || 'dark'} label={customBadge.label} className={`w-fit inline-block ${customBadge.className || ''}`} />
                    }

                </Text>
                <Text variant='label' className='whitespace-normal text-gray-1100'>
                    {descriptionArray.length > 0 ? getDescription.join(' | ') : description}
                </Text>
                {
                    isRelieving && (
                        <div className='bg-gray-100 p-1'>
                            <Text variant='body'>
                                Relieving on: <span className='text-red-800'>{relievingDate}</span>
                            </Text>
                        </div>
                    )
                }
            </div>

        </div>
    );
}

export default ResourceProfile;
